<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "MediaGroupWrapper"
    }
</script>

<style scoped>

</style>